import api from './api';

/** Customer-maintenance options + edit context (docs use the generic documents
 *  service with basePath '/customers-maint'). */

export interface PersonOption {
  username: string;
  displayname: string;
}

export interface MarketOption {
  recno: number;
  market: string;
  salesrep: string;
}

export interface MasterCustomerOption {
  recno: number;
  custname: string;
  keyaccount: string;
  address: string;
  city: string;
  state: string;
}

export interface CustomerFormOptions {
  markets: MarketOption[];
  salesReps: PersonOption[];
  csrs: PersonOption[];
  cstDispatchers: PersonOption[];
  keyAccounts: string[];
  communication: string[];
  custTypes: string[];
  regions: string[];
  masterCustomers: MasterCustomerOption[];
}

const customersService = {
  async formOptions(signal?: AbortSignal): Promise<CustomerFormOptions> {
    const res = await api.get('/customers-maint/form-options', { signal });
    return res.data as CustomerFormOptions;
  },

  async context(recno: number, signal?: AbortSignal): Promise<{ inUse: boolean; deletable: boolean }> {
    const res = await api.get(`/customers-maint/${recno}/context`, { signal });
    return res.data as { inUse: boolean; deletable: boolean };
  },
};

export default customersService;
